import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import IconButtonNonReact from '../components/IconButtonNonReact';
import Urls from '../urls/Urls';
import UrlHelper from '../core/UrlHelper';
import Once from '../core/Once';
import PropertyBindingFactory from '../mvvm/PropertyBindingFactory';
import PlotStatus from '../site/PlotStatus';
import AssetsManager from '../assets_management/AssetsManager';
import Star from '../components/Star';
export default class HouseTypesViewerEntryStatusesEntry {
	constructor({plotsToConsider, plotStatus}){
		this._plotsToConsider = plotsToConsider;
		this._plotStatus = plotStatus;
		this.update = this.update.bind(this);
		this._element = document.createElement('div');
		this._element.classList.add('statuses-entry');
		this._element.classList.add(PlotStatus.getCssName(plotStatus));
		this._dotElement = document.createElement('div');
		this._dotElement.classList.add('dot');
		this._element.appendChild(this._dotElement);
		this._nameElement= document.createElement('div');
		this._nameElement.innerHTML = PlotStatus.getDescription(plotStatus);
		this._nameElement.classList.add('name');
		this._element.appendChild(this._nameElement);
		this._nElement= document.createElement('div');
		this._nElement.classList.add('n');
		this._element.appendChild(this._nElement);
		this._updateOnce = new Once(this.update);
		plotsToConsider.forEach(plot=>{
			PropertyBindingFactory.standard(this, plot, 'status', this._updateOnce.trigger);
		});
	}
	update(){
		let n=0;
		this._plotsToConsider.forEach(plot=>{
			const status = plot.status;
			if(status!==this._plotStatus)return;
			n++;
		});
		this._nElement.innerHTML = String(n);
		if(n>0)
			this._element.classList.add('visible');
		else this._element.classList.remove('visible');
	}
	get element(){
		return this._element;
	}
}
